// extracted by mini-css-extract-plugin
export var RichText = "RichText-module--RichText--45g0Y";
export var aniSpin = "RichText-module--ani-spin--M904V";